import React from "react";
import { SEO, MarkdownContent } from "@bluefin/components";
import { Grid, Segment } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
} from "../utils/utils";

export default class SubscribePage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
        />
        <Grid
          className={"custom-page-subscribe custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row className={""} style={{ padding: 16 }} textAlign={"center"}>
            <Grid.Column
              className={""}
              style={{ padding: 16 }}
              width={10}
              textAlign={"center"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "c45a491a-aa5c-4212-ae0b-cba9b31a6122",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className={""} style={{ padding: 16 }} textAlign={"center"}>
            <Grid.Column
              className={""}
              style={{ padding: 16 }}
              width={10}
              textAlign={"center"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "60dcef8c-e2f9-4cbf-8c43-4edd2f2a23c1",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className={""} style={{ padding: 16 }} columns={1}>
            <Grid.Column className={""} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__c67754b3-9dee-4051-9b37-ef48b4d08482"}
                >
                  <div id={"mc_embed_shell"}>
                    <div id={"mc_embed_signup"}>
                      <form
                        action={
                          "https://skintuitionky.us19.list-manage.com/subscribe/post?u=cbff5a129a95fdcd9c4190758&amp;id=90925da6a7&amp;f_id=008c13e4f0"
                        }
                        method={"post"}
                        id={"mc-embedded-subscribe-form"}
                        name={"mc-embedded-subscribe-form"}
                        class={"validate"}
                        target={"_blank"}
                      >
                        <div id={"mc_embed_signup_scroll"}>
                          <h2>Subscribe</h2>
                          <div className={"mc-field-group"}>
                            <label htmlFor={"mce-EMAIL"}>Email Address*</label>
                            <input
                              type={"email"}
                              id={"mce-EMAIL"}
                              name={"EMAIL"}
                              required={true}
                              className={"required email"}
                            />
                            <span
                              id={"mce-EMAIL-HELPERTEXT"}
                              className={"helper_text"}
                            />
                          </div>
                          <div className={"mc-field-group"}>
                            <label htmlFor={"mce-FNAME"}>First Name</label>
                            <input
                              type={"text"}
                              id={"mce-FNAME"}
                              name={"FNAME"}
                              required={false}
                              className={"text"}
                            />
                            <span
                              id={"mce-EMAIL-HELPERTEXT"}
                              className={"helper_text"}
                            />
                          </div>
                          <div className={"mc-field-group"}>
                            <label htmlFor={"mce-LNAME"}>Last Name</label>
                            <input
                              type={"text"}
                              id={"mce-LNAME"}
                              name={"LNAME"}
                              required={false}
                              className={"text"}
                            />
                            <span
                              id={"mce-EMAIL-HELPERTEXT"}
                              className={"helper_text"}
                            />
                          </div>
                          <div hidden={""}>
                            <input
                              type={"hidden"}
                              name={"tags"}
                              value={"11200167"}
                            />
                          </div>
                          <div id={"mce-responses"} className={"clear"}>
                            <div
                              id={"mce-error-response"}
                              className={"response"}
                            />
                            <div
                              id={"mce-success-response"}
                              className={"response"}
                            />
                          </div>
                          <div aria-hidden={true} className={"other-input"}>
                            <input
                              type={"text"}
                              tabIndex={"-1"}
                              name={"b_cbff5a129a95fdcd9c4190758_90925da6a7"}
                            />
                          </div>
                          <div className={"clear"}>
                            <input
                              type={"submit"}
                              name={"subscribe"}
                              id={"mc-embedded-subscribe"}
                              className={"button"}
                              value={"Subscribe"}
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 23818 }) {
      title
      description
      components {
        files {
          file
        }
        order
        fastId
        componentIdentifier
        contentNodes {
          content
        }
      }
    }
  }
`;
